import { render, staticRenderFns } from "./MarsDATA.vue?vue&type=template&id=255a0d10&scoped=true&"
import script from "./MarsDATA.vue?vue&type=script&lang=js&"
export * from "./MarsDATA.vue?vue&type=script&lang=js&"
import style0 from "./MarsDATA.vue?vue&type=style&index=0&id=255a0d10&lang=scss&scoped=true&"
import style1 from "./MarsDATA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a0d10",
  null
  
)

export default component.exports